import styled from 'styled-components';

import {
  CenteredLoader, Text as TextLayoutComponent,
  Button as ButtonLayoutComponent,
} from '@playbookux/playbook-web-core';

const ErrorMessage = styled(TextLayoutComponent)``;

const Loader = styled(CenteredLoader)``;

const ContainerTranscripts = styled.div`
  flex: 1;
  overflow-y: hidden;
  margin-right: 30px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContainerToggle = styled.div`
  display: flex;
`;

const TextToggle = styled(TextLayoutComponent)`
  margin-left: 10px;
  font-size: 12px;
`;

const ButtonResumeAutoscroll = styled(ButtonLayoutComponent)`
`;

export {
  ErrorMessage,
  Loader,
  ContainerTranscripts,
  TextToggle,
  ContainerToggle,
  ButtonResumeAutoscroll,
};
